import { apiGetRequest } from 'utils/http/apiHttp';

const apiSystemSetting = {
  getSetting: (settingKey: string) => {
    return apiGetRequest(`system/setting/${settingKey}`);
  },
};

export default apiSystemSetting;
